import FactureCloturePopupController from './facture.cloture.popup.controller';
import FactureCloturePopupTemplate from './facture.cloture.popup.html';
export default {
	bindings: {
		modalInstance: '=',
		resolve: '='
	},
	template: FactureCloturePopupTemplate,
	controller: FactureCloturePopupController
};
